<template>
  <div class="product-replacement-container">
    <div class="product-details">{{ productDetails.name }} ({{ productDetails.productCode }})</div>
    <mds-table class="action-fund-table">
      <mds-thead>
        <mds-th > Menu </mds-th>
        <mds-th style="width: 100px;"> Status </mds-th>
        <mds-th style="width: 100px;"> Pending </mds-th>
        <mds-th style="width: 320px;"> Replacement Fund Name </mds-th>
        <mds-th style="width: 100px;"> Ticker </mds-th>
        <mds-th> Sec ID </mds-th>
        <mds-th> Active </mds-th>
      </mds-thead>
      <mds-tbody>
        <mds-tr class="fund-replacement-row" v-for="(replacement, index) in productDetails.replacements" :key="index">
          <mds-td class="fund-replacement-column">
            <div v-if="replacement.menus">
              {{replacement.menus[0].menuName}}
            </div>
          </mds-td>
          <mds-td class="fund-replacement-column">
            <status-icons :status="[{ name: replacement.fundStatus.name }]"/>
          </mds-td>
          <mds-td class="fund-replacement-column">
            <div v-if="replacement.isPending">
              <mds-button
                class="button-icon"
                variation="icon-only"
                icon="clock-back"
                type="button"
              ></mds-button>
            </div>
          </mds-td>
          <mds-td class="fund-replacement-column"> {{replacement.displayName}} </mds-td>
          <mds-td class="fund-replacement-column"> {{replacement.ticker}} </mds-td>
          <mds-td class="fund-replacement-column"> {{replacement.secID}} </mds-td>
          <mds-td class="fund-replacement-column"> {{ replacement.activeDateFormatted }} </mds-td>
        </mds-tr>
      </mds-tbody>
    </mds-table>
  </div>
</template>
<script>

import {
  MdsTable, MdsThead, MdsTh, MdsTbody, MdsTr, MdsTd,
} from '@mds/data-table';
import StatusIcons from '@/components/atoms/StatusIcons';

export default {
  name: 'product-menu-replacement',
  components: {
    MdsTable,
    MdsThead,
    MdsTh,
    MdsTbody,
    MdsTr,
    MdsTd,
    StatusIcons,
  },
  props: {
    data: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      productDetails: this.data.product,
    };
  },
};
</script>
<style lang="scss">
.product-replacement-container {
  padding: 0 $mds-space-3-x $mds-space-3-x;
  .product-details {
    @include mds-level-6-heading($bold: true);
    margin-bottom: $mds-space-4-x;
  }
  .fund-replacement-column {
    padding-top: $mds-space-1-x;
    padding-bottom: $mds-space-1-x;
  }
}
</style>
